import Component from "@base/js/component";
import Drawer from "@components/drawer/drawer";
import $ from "jquery";

export default class MapPathing extends Component {
  // Defines the element selector which will initialize this component
  static selector = ".indicator-hero";

  // Defines children that needs to be queried as part of this component
  static children = {
    selectionItems: [
      ".indicator-hero__selection-primary .indicator-hero__selection-item",
    ],
    selectionHeading:
      ".indicator-hero__selection-primary .indicator-hero__selection-heading",
    selectionItemsContainer:
      ".indicator-hero__selection-primary .indicator-hero__selection-selections",
    selectionHeadingText:
      ".indicator-hero__selection-primary .indicator-hero__selection-heading-text",
    secondarySelection: ".indicator-hero__selection-secondary",
    secondarySelectionItemsContainer:
      ".indicator-hero__selection-secondary .indicator-hero__selection-selections",
    secondarySelectionItems: [
      ".indicator-hero__selection-secondary .indicator-hero__selection-item",
    ],
    secondarySelectionHeading:
      ".indicator-hero__selection-secondary .indicator-hero__selection-heading",
    secondarySelectionHeadingText:
      ".indicator-hero__selection-secondary .indicator-hero__selection-heading-text",
  };

  // Defines sub components that needs to be queried as part of this component
  static members = {
    drawers: [Drawer],
  };

  // Defines event handlers to attach to children
  eventHandlers = {
    selectionItems: {
      click: this.onSelectionStateClick,
    },
    secondarySelectionItems: {
      click: this.onSecondarySelectionStateClick,
    },
    selectionHeading: {
      click: this.onSecondarySelectionHeaderClick,
    },
    secondarySelectionHeading: {
      click: this.checkIfSelectionHasItem,
    },
    selectionItemsContainer: {
      keyup: this.onMultiSelectKeyUp,
    },
    secondarySelectionItemsContainer: {
      keyup: this.onMultiSelectKeyUp,
    },
  };

  // Will be called upon component instantiation
  afterInit() {
    const { secondarySelectionItems } = this.children;

    // remove hidden attributes when there is selection items
    if (secondarySelectionItems && secondarySelectionItems.length > 0) {
      secondarySelectionItems.classList.remove(
        "indicator-hero__selection-secondary-hidden"
      );
    }

    // Add event listener to check if the user clicks outside the container
    $(document).on("click", (event) => {
      if (
        !$(event.target).closest(".indicator-hero__selection-primary").length
      ) {
        if (
          $(".indicator-hero__selection-primary .drawer--expanded").length > 0
        )
          this.children.selectionHeading.click();
      }
      if (
        !$(event.target).closest(".indicator-hero__selection-secondary").length
      ) {
        if (
          $(".indicator-hero__selection-secondary .drawer--expanded").length > 0
        )
          this.children.secondarySelectionHeading.click();
      }
      if (
        !$(event.target).closest(".indicator-chart__single-select-container")
          .length
      ) {
        const closestSingleSelect = $(
          ".indicator-chart__single-select-container .rah-static--height-auto"
        );
        if (closestSingleSelect.length > 0) {
          const headerSelection = closestSingleSelect
            .parent()
            .find(".indicator-chart__select-header");
          headerSelection.trigger("click");
        }
      }
      if (
        !$(event.target).closest(".indicator-chart__download-button-container")
          .length
      ) {
        const closestDownloadDropdown = $(
          ".indicator-chart__download-button-container .show-tooltip"
        );
        if (closestDownloadDropdown.length > 0) {
          const downloadButton = closestDownloadDropdown
            .parent()
            .find(".indicator-chart__download-button");
          downloadButton.trigger("click");
        }
      }
    });

    $(".indicator-hero .drawer__header").on("click", (event) => {
      const selectionsParent = $(event.target).closest(".drawer");

      if (selectionsParent.length > 0) {
        if (selectionsParent.hasClass("drawer--expanded")) {
          selectionsParent
            .find(".indicator-hero__selection-item")
            .attr("tabindex", "-1");
        } else {
          selectionsParent
            .find(".indicator-hero__selection-item")
            .attr("tabindex", "-1");
          selectionsParent
            .find(".indicator-hero__selection-item:first-child")
            .attr("tabindex", "0");
        }
      }
    });

    $(".indicator-hero .drawer__header").on("keydown", (e) => {
      if (/^(13|32)$/.test(e.which)) {
        e.preventDefault();
        const selectionsParent = $(e.target).closest(".drawer");

        if (selectionsParent.length > 0) {
          if (selectionsParent.hasClass("drawer--expanded")) {
            selectionsParent
              .find(".indicator-hero__selection-item")
              .attr("tabindex", "-1");
          } else {
            selectionsParent
              .find(".indicator-hero__selection-item")
              .attr("tabindex", "-1");
            selectionsParent
              .find(".indicator-hero__selection-item:first-child")
              .attr("tabindex", "0");
          }
        }
      }
    });

    if (
      this.children.selectionHeading.classList.contains(
        "indicator-hero__performance-indicator"
      )
    ) {
      window.onbeforeunload = () => {
        const performanceArea = this.children.selectionHeading.getAttribute(
          "data-selected-value"
        );
        if (performanceArea) {
          window.history.replaceState(
            { performance_area: performanceArea },
            "",
            `?performance_area=${performanceArea}`
          );
        }
      };

      // check if url has query
      const params = new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, prop) => searchParams.get(prop),
      });

      if (params) {
        const perfArea = params.performance_area;
        if (perfArea) {
          const filterValues = [
            ...$(".indicator-hero__selection-selections > [data-value]"),
          ].map((d) => $(d).attr("data-value"));
          if (filterValues.includes(perfArea)) {
            this.updateSelectionValue(
              $(
                `.indicator-hero__selection-selections > [data-value=${perfArea}]`
              )
                .text()
                .trim(),
              perfArea
            );
          }
        }
      }
    }
  }

  onMultiSelectKeyUp(e) {
    const itm = e.target;
    const prev = itm.previousElementSibling;
    const next = itm.nextElementSibling;
    if (e.which === 38 && prev) {
      // On arrow up move focus to the previous item.
      itm.setAttribute("tabindex", "-1");
      prev.setAttribute("tabindex", "0");
      prev.focus();
    } else if (e.which === 40 && next) {
      // On arrow down move focus to the next item.
      itm.setAttribute("tabindex", "-1");
      next.setAttribute("tabindex", "0");
      next.focus();
    } else if (e.which === 27) {
      // click header when user press esc, toggle expanded
      $(itm).closest(".drawer__header").trigger("click");
    } else if (/^(13|32)$/.test(e.which)) {
      e.preventDefault();
      itm.click();
    }
  }

  onSelectionStateClick(e) {
    const { selectionHeading } = this.children;
    const item = e.target;
    const value = item.getAttribute("data-value");
    const name = item.innerText;
    if (name && value) {
      selectionHeading.click();
      $(selectionHeading).closest(".drawer__header").trigger("focus");
      this.updateSelectionValue(name, value);
    }
  }

  onSecondarySelectionHeaderClick(e) {
    const { secondarySelectionItems } = this.children;
    if (secondarySelectionItems.length <= 0) {
      e.preventDefault();
    }
  }

  checkIfSelectionHasItem(e) {
    const { secondarySelectionHeadingText } = this.children;
    if (
      secondarySelectionHeadingText.getAttribute("data-no-indicator") === "true"
    ) {
      e.preventDefault();
      e.cancelBubble = true;
      if (e.stopPropagation) e.stopPropagation();
    }
  }

  onSecondarySelectionStateClick(e) {
    const { secondarySelectionHeading } = this.children;
    const item = e.target;
    const value = item.getAttribute("data-value");
    const name = item.innerText;
    if (name && value) {
      secondarySelectionHeading.click();
      $(secondarySelectionHeading).closest(".drawer__header").trigger("focus");
      this.updateSecondarySelectionValue(name, value);
    }
  }

  updateSelectionValue(name, value) {
    const length = 50;
    let myTruncatedName = name.substring(0, length);
    if (name.length > length) {
      myTruncatedName += "...";
    }

    const {
      selectionHeading,
      selectionHeadingText,
      secondarySelectionHeadingText,
      secondarySelection,
    } = this.children;
    selectionHeadingText.innerHTML = myTruncatedName;
    selectionHeading.setAttribute("data-selected-value", value);
    // window.location.href = value;
    selectionHeading.focus();
    if (
      selectionHeading.classList.contains(
        "indicator-hero__performance-indicator"
      )
    ) {
      // Call ajax.
      const defaultSecondaryLabel = secondarySelectionHeadingText
        .getAttribute("data-default-label")
        .toString()
        .trim();
      secondarySelectionHeadingText.innerHTML = "Loading...";
      secondarySelection.classList.remove(
        "indicator-hero__selection-secondary-hidden"
      );
      const link = `/api/v1/performance-indicator/${value}`;
      const self = this;
      $.ajax({
        type: "GET",
        url: link,
        dataType: "json",
        success(data) {
          if (data.result) {
            self.populateSecondarySelection(data.result, defaultSecondaryLabel);
          } else {
            self.populateSecondarySelection(data, defaultSecondaryLabel);
          }
        },
      });
    }

    if (
      selectionHeading.classList.contains("indicator-hero__state") &&
      value.includes("/")
    ) {
      setTimeout(() => {
        window.location.href = value;
      }, 400);
    }
  }

  populateSecondarySelection(data, defaultLabel) {
    const { secondarySelectionHeadingText, secondarySelectionItemsContainer } =
      this.children;
    const self = this;
    $(secondarySelectionItemsContainer).html("");
    secondarySelectionHeadingText.removeAttribute("data-no-indicator");
    if (data && data.length > 0) {
      data.forEach((item) => {
        const tempElement = $(
          `<div class="indicator-hero__selection-item" role="button" aria-label="Go to ${item.name} page" data-value="${item.value}">${item.name}</div>`
        );
        tempElement.on("click", (ev) => {
          self.onSecondarySelectionStateClick(ev);
        });
        $(secondarySelectionItemsContainer).append(tempElement);
      });
      secondarySelectionHeadingText.innerHTML = defaultLabel;
    } else {
      secondarySelectionHeadingText.innerHTML =
        "No indicators available for this performance area";
      secondarySelectionHeadingText.setAttribute("data-no-indicator", "true");
    }
  }

  updateSecondarySelectionValue(name, value) {
    const length = 50;
    let myTruncatedName = name.substring(0, length);
    if (name.length > length) {
      myTruncatedName += "...";
    }

    const {
      selectionHeading,
      secondarySelectionHeading,
      secondarySelectionHeadingText,
    } = this.children;
    secondarySelectionHeadingText.innerHTML = myTruncatedName;
    secondarySelectionHeading.setAttribute("data-selected-value", value);

    if (
      selectionHeading.classList.contains(
        "indicator-hero__performance-indicator"
      )
    ) {
      const performanceArea =
        `?performance_area=${this.children.selectionHeading.getAttribute(
          "data-selected-value"
        )}` || "";
      setTimeout(() => {
        window.location.href = value + performanceArea;
      }, 400);
    }
  }
}

// Remove this line if this component is not intended
// to initialize on DOM load.
MapPathing.init();
